<template>
    <div class="">
            <h1 class="text-muted mb-4">
                <vue-fontawesome class="mr-2" icon="sort"></vue-fontawesome>
                Stock
            </h1>
            
        <div>            
            <div class="d-flex justify-content-between">
                <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                        <li class="nav-item">
                            <a class="nav-link active" 
                                id="pills-home-tab" 
                                data-toggle="pill" 
                                href="#pills-home" 
                                role="tab" 
                                aria-controls="pills-home" 
                                aria-selected="true">                                                        
                                Stock
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" 
                                id="pills-transfers-tab" 
                                data-toggle="pill" 
                                href="#pills-transfers" 
                                role="tab" 
                                aria-controls="pills-transfers" 
                                aria-selected="false">
                                Transfers
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" 
                                id="pills-contact-tab" 
                                data-toggle="pill" 
                                href="#pills-contact" 
                                role="tab" 
                                aria-controls="pills-contact" 
                                aria-selected="false">
                                Adjustments
                            </a>
                        </li>								
                </ul>             
            </div>									
            <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" 
                    id="pills-home" 
                    role="tabpanel" 
                    aria-labelledby="pills-home-tab">
                    <div class="mb-4 d-flex justify-content-between">
                        <!-- right -->
                        <section class="d-flex">                           
                            <div class="dropdown">
                                <a class="btn btn-outline-success dropdown-toggle" 
                                    href="#" role="button" id="dropdownMenuLink" 
                                    data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <vue-fontawesome class="mr-2" icon="filter"></vue-fontawesome>	Filter
                                </a>                                
                                <div class="dropdown-menu border-0 shadow p-3" aria-labelledby="dropdownMenuLink" style="min-width: 25vw">
                                        <div class="form-group d-flex justify-content-between">
                                            <label class="p-2">Search</label>
                                            <input type="text" class="col-8 form-control" v-model="search"> 
                                        </div>                                        
                                </div>
                            </div>
                            <div class="ml-2">
                                <button class="btn btn-outline-success"
                                    @click="$exportTable('stockTable','stock.csv')">                                
                                    <vue-fontawesome class="mr-2" icon="file-excel-o"></vue-fontawesome>
                                    Export
                                </button>
                            </div>                           	
                            <div class="ml-2">
                                <div class="form-group d-flex justify-content-between">
                                    <label class="p-2"> <vue-fontawesome class="mr-2" icon="search"></vue-fontawesome></label>
                                    <input type="text" placeholder="search" class="form-control" v-model="search"> 
                                </div> 
                            </div>
                        </section>  
                        <!-- add buttons --> 
                        <div>
                            <router-link class="btn btn-success" to="/stock-take">
                                Count stock
                            </router-link>  
                        </div>                                   																							
                    </div> 
                    <!-- STOCK TABLE ANND DEPENDENCIES -->
                    <div class="rounded shadow border border-light p-2">
                        <!--top pagination -->
                        <div class="d-flex justify-content-between bg-light rounded">
                            <div class="p-3">
                                <span class="font-weight-bold" v-if="stocks">
                                    <span class="text-muted">Found</span> {{stocks.length}}
                                </span>
                            </div>                           
                            <!-- paginator -->
                            <div class="p-2">
                                <button class="btn" @click="prevPage"
                                    :disabled="pageNumber == 0">
                                    <i class="arrow left"></i>
                                </button>
                                <span class="p-3">{{pageNumber + 1}} / {{pageCount}}</span>
                                <button class="btn" @click="nextPage"
                                    :disabled="(pageNumber+1) == pageCount">
                                    <i class="arrow right"></i>
                                </button>
                            </div>                            
                        </div>
                        <table class="table table-borderless table-responsive-sm" id="stockTable">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th scope="col">Product</th>
                                    <th scope="col">In stock</th>
                                    <th scope="col">Reorder level</th>                               
                                    <th scope="col"></th>
                                </tr>
                            </thead>																	
                            <tbody v-if="stocks && stocks.length">
                                <tr v-for="(stock,index) in paginatedData" :key="index">

                                    <div class="p-3">
                                        <small v-if="stock.total > 0"><span class="ml-5 badge badge-pill badge-success text-success">...</span></small>
                                        <small v-else><span class="ml-5 badge badge-pill badge-danger text-danger">...</span>    </small>
                                    </div>
                                    <td scope="row">{{stock.product.name}}</td>
                                    <td class="text-success" :class="{'text-danger': stock.total < 1}">
                                        {{stock.total | intcomma}}
                                    </td>
                                    <td>{{stock.minimumRequired | intcomma}}</td>                                                              
                                    <div>
                                        <span class="p-2 rounded mt-0" style="position:absolute;right: 0px;">                                            
                                            <span class="d-flex mr-4">
                                                <router-link class="btn btn-outline-primary border-0" 
                                                    :to="{ path: `stock-detail/`, query: { stock : stock }}">
                                                    View per location
                                                </router-link>                                              
                                            </span>										
                                        </span>
                                    </div>
                                </tr>														
                            </tbody>					
                        </table>
                        <div class="p-3 d-flex justify-content-center"
                            v-if="stocks && ! stocks.length">
                            No records to show
                        </div>
                        <div class="p-3 d-flex justify-content-center"
                            v-if="! stocks">
                            <div class="spinner-border p-3 m-5" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>	
                        <!-- pagination bottom -->
                        <div class="d-flex justify-content-end rounded bg-light">
                            <button class="btn" @click="prevPage"
                                :disabled="pageNumber == 0">
                                <i class="arrow left"></i>
                            </button>
                            <span class="p-3">{{pageNumber + 1}} / {{pageCount}}</span>
                            <button class="btn" @click="nextPage"
                                :disabled="(pageNumber+1) == pageCount">
                                <i class="arrow right"></i>
                            </button>
                        </div>
                        </div>                   
                </div>
                <div class="tab-pane fade" id="pills-transfers" role="tabpanel" aria-labelledby="pills-transfers-tab">
                    <div class="rounded shadow border border-light p-2">
                        <stockTransfers/>
                    </div>                   
                </div>
                <div class="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                    <adjustments/>
                </div>
            </div> 		  
        </div>	
    </div>
</template>
<script>
import stockTransfers from './subviews/transfers.vue'    
import adjustments from './subviews/adjustments.vue'  
export default {
    name: 'stock',
    components:{stockTransfers,adjustments},
    props: {
        msg: String
    },
    data(){
        return{ 
            pageNumber: 0,  // default to page 1
            size:100, 
            search: '',          
            stocks:null,         
            //receipt modal.
            receipt_modal_data:null,
        }
    },
    computed:{
        account_switched(){
			return this.$store.state.account_switch_count
		},
        destroy: function()  {
            return this.$route.query.destroy
        },
        pageCount(){		
            let l = this.stocks.length,
                s = this.size;
            return Math.ceil(l/s);
        },
        paginatedData(){                        
            const start = this.pageNumber * this.size,
            end = start + this.size
            if (! this.search.length){                                
                return this.stocks.slice(start, end)
            }            
            else{                                            
                var filtered_list = this.stocks.filter((s)=>{
                    return s.product.name.toUpperCase().includes(this.search.toUpperCase())
                })                             
                return filtered_list.slice(start, end);
            }
        }
    },
    watch:{
        account_switched: function(){
			this.getStock()
		}, 
        destroy: function(){
            if (this.destroy == true){
                this.getStock()
            }
        },
        search: function(){
            if (this.search){
                this.pageNumber = 0
            }            
        }
    },
    mounted(){           
        this.getStock()
    },
    methods:{		 
        nextPage(){
            this.pageNumber++
        },
        prevPage(){
            this.pageNumber--
        },       
        //get stocks by user		
        getStock:function(){                          
            this.$http({
                method:'get',				
                url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/stock`,               
                headers:{
                    Authorization: JSON.parse(localStorage.getItem('auth_token'))
                }
            }).then((response)=>{							
                this.stocks = response.data                
            }).catch((err)=>{
                alert(err)
            })
        },      
    }
}
</script>